import React from "react";
import LandingPage from "./pages/LandingPage";
import MyGlobalStyles from "./styles/GlobalStyles";
// import "./App.css";

function App() {
	return (
		<>
			<MyGlobalStyles />
			<LandingPage />
		</>
	);
}

export default App;
